import {ApiUrls} from 'shared/config/model/urls';

import {useState} from 'react';
import {SubmitHandler} from 'react-hook-form';

import {buildHttpIncidentExportRequest} from 'features/http/lib/httpIncidentFiltersView';
import {IHttpIncidentFiltersForm} from 'features/http/model/HttpIncident/IHttpIncidentFiltersForm';
import {useBatchOperation, IBatchResult} from 'entities/monitor';

export interface IUseHttpIncidentExport {
    result: IBatchResult | undefined,
    isLoading: boolean,
    progress: number,
    onSubmit: SubmitHandler<IHttpIncidentFiltersForm>,
    handleCloseResult: () => void,
}

export const useHttpIncidentExport = (handleClose: () => void): IUseHttpIncidentExport => {
    const [result, setResult] = useState<IBatchResult | undefined>();
    const {trigger, isLoading, progress} = useBatchOperation();

    const onSubmit: SubmitHandler<IHttpIncidentFiltersForm> = async(values) => {
        await trigger(
            ApiUrls.INCIDENTS_EXPORT,
            'POST',
            buildHttpIncidentExportRequest(values),
            setResult,
        );
    };

    const handleCloseResult = () => {
        handleClose();
        setResult(undefined);
    };

    return {result, isLoading, progress, onSubmit, handleCloseResult};
};

export default useHttpIncidentExport;
